<template>
    <div class="lotery_hit_egg_container" >
        <div class="home_btn" @click="backHome">
            <img src="../assets/defult/img/Home.png" alt="" srcset="" />
        </div>

        <div class="title">
            <img src="../assets/defult/img/egg_title.png" alt="" srcset="" />
        </div>

        <div class="egg_blue egg" @click="breakegg('b')">
            <img src="../assets/defult/img/blueegg.png" />
        </div>
        <div class="egg_green egg" @click="breakegg('g')">
            <img src="../assets/defult/img/greenegg.png" />
        </div>
        <div class="egg_red egg" @click="breakegg('r')">
            <img src="../assets/defult/img/redegg.png" />
        </div>

        <div class="dialog" v-if="showBreakEggAnimate">
          <div class="dialog_content_hit_egg">
            <img :src="breakEggImgList[aniIndex]" class="animat_imgs" />
          </div>
        </div>

        <div class="dialog" v-if="showModalTrigger">
            <div class="dialog_content">
              <div class="dialog_alert">
                <div class="text">
                  恭喜你獲得<br />
                  XXX元
                </div>

                <div class="close_btn">
                  <!-- <img src="../assets/defult/img/dialog_btn.png" @click="showModalTrigger = !showModalTrigger"> -->
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import "../assets/defult/css/hitegg.css";
import b01png from "../assets/defult/img/eggs/b/egg_b_01.png";
import b02png from "../assets/defult/img/eggs/b/egg_b_02.png";
import b03png from "../assets/defult/img/eggs/b/egg_b_03.png";
import b04png from "../assets/defult/img/eggs/b/egg_b_04.png";
import b05png from "../assets/defult/img/eggs/b/egg_b_05.png";
import b06png from "../assets/defult/img/eggs/b/egg_b_06.png";
import b07png from "../assets/defult/img/eggs/b/egg_b_07.png";
import b08png from "../assets/defult/img/eggs/b/egg_b_08.png";
import b09png from "../assets/defult/img/eggs/b/egg_b_09.png";
import b10png from "../assets/defult/img/eggs/b/egg_b_10.png";
import b11png from "../assets/defult/img/eggs/b/egg_b_11.png";
import b12png from "../assets/defult/img/eggs/b/egg_b_12.png";
import b13png from "../assets/defult/img/eggs/b/egg_b_13.png";
import b14png from "../assets/defult/img/eggs/b/egg_b_14.png";
import b15png from "../assets/defult/img/eggs/b/egg_b_15.png";
import b16png from "../assets/defult/img/eggs/b/egg_b_16.png";
import b17png from "../assets/defult/img/eggs/b/egg_b_17.png";
import b18png from "../assets/defult/img/eggs/b/egg_b_18.png";
import b19png from "../assets/defult/img/eggs/b/egg_b_19.png";
import b20png from "../assets/defult/img/eggs/b/egg_b_20.png";
import b21png from "../assets/defult/img/eggs/b/egg_b_21.png";
import b22png from "../assets/defult/img/eggs/b/egg_b_22.png";

import g01png from "../assets/defult/img/eggs/g/egg_g_01.png";
import g02png from "../assets/defult/img/eggs/g/egg_g_02.png";
import g03png from "../assets/defult/img/eggs/g/egg_g_03.png";
import g04png from "../assets/defult/img/eggs/g/egg_g_04.png";
import g05png from "../assets/defult/img/eggs/g/egg_g_05.png";
import g06png from "../assets/defult/img/eggs/g/egg_g_06.png";
import g07png from "../assets/defult/img/eggs/g/egg_g_07.png";
import g08png from "../assets/defult/img/eggs/g/egg_g_08.png";
import g09png from "../assets/defult/img/eggs/g/egg_g_09.png";
import g10png from "../assets/defult/img/eggs/g/egg_g_10.png";
import g11png from "../assets/defult/img/eggs/g/egg_g_11.png";
import g12png from "../assets/defult/img/eggs/g/egg_g_12.png";
import g13png from "../assets/defult/img/eggs/g/egg_g_13.png";
import g14png from "../assets/defult/img/eggs/g/egg_g_14.png";
import g15png from "../assets/defult/img/eggs/g/egg_g_15.png";
import g16png from "../assets/defult/img/eggs/g/egg_g_16.png";
import g17png from "../assets/defult/img/eggs/g/egg_g_17.png";
import g18png from "../assets/defult/img/eggs/g/egg_g_18.png";
import g19png from "../assets/defult/img/eggs/g/egg_g_19.png";
import g20png from "../assets/defult/img/eggs/g/egg_g_20.png";
import g21png from "../assets/defult/img/eggs/g/egg_g_21.png";
import g22png from "../assets/defult/img/eggs/g/egg_g_22.png";

import r01png from "../assets/defult/img/eggs/r/egg_r_01.png";
import r02png from "../assets/defult/img/eggs/r/egg_r_02.png";
import r03png from "../assets/defult/img/eggs/r/egg_r_03.png";
import r04png from "../assets/defult/img/eggs/r/egg_r_04.png";
import r05png from "../assets/defult/img/eggs/r/egg_r_05.png";
import r06png from "../assets/defult/img/eggs/r/egg_r_06.png";
import r07png from "../assets/defult/img/eggs/r/egg_r_07.png";
import r08png from "../assets/defult/img/eggs/r/egg_r_08.png";
import r09png from "../assets/defult/img/eggs/r/egg_r_09.png";
import r10png from "../assets/defult/img/eggs/r/egg_r_10.png";
import r11png from "../assets/defult/img/eggs/r/egg_r_11.png";
import r12png from "../assets/defult/img/eggs/r/egg_r_12.png";
import r13png from "../assets/defult/img/eggs/r/egg_r_13.png";
import r14png from "../assets/defult/img/eggs/r/egg_r_14.png";
import r15png from "../assets/defult/img/eggs/r/egg_r_15.png";
import r16png from "../assets/defult/img/eggs/r/egg_r_16.png";
import r17png from "../assets/defult/img/eggs/r/egg_r_17.png";
import r18png from "../assets/defult/img/eggs/r/egg_r_18.png";
import r19png from "../assets/defult/img/eggs/r/egg_r_19.png";
import r20png from "../assets/defult/img/eggs/r/egg_r_20.png";
import r21png from "../assets/defult/img/eggs/r/egg_r_21.png";
import r22png from "../assets/defult/img/eggs/r/egg_r_22.png";
export default {
    name: "LotteryHitEgg",

    data: () => ({
        eggb_ani: [
            b01png,
            b02png,
            b03png,
            b04png,
            b05png,
            b06png,
            b07png,
            b08png,
            b09png,
            b10png,
            b11png,
            b12png,
            b13png,
            b14png,
            b15png,
            b16png,
            b17png,
            b18png,
            b19png,
            b20png,
            b21png,
            b22png,
        ],
        eggg_ani: [
            g01png,
            g02png,
            g03png,
            g04png,
            g05png,
            g06png,
            g07png,
            g08png,
            g09png,
            g10png,
            g11png,
            g12png,
            g13png,
            g14png,
            g15png,
            g16png,
            g17png,
            g18png,
            g19png,
            g20png,
            g21png,
            g22png,
        ],
        eggr_ani: [
            r01png,
            r02png,
            r03png,
            r04png,
            r05png,
            r06png,
            r07png,
            r08png,
            r09png,
            r10png,
            r11png,
            r12png,
            r13png,
            r14png,
            r15png,
            r16png,
            r17png,
            r18png,
            r19png,
            r20png,
            r21png,
            r22png,
        ],
        breakEggImgList : [],
        showBreakEggAnimate : false,
        showModalTrigger : false,
        aniIndex: 0,
        fps: 66,
    }),
    methods: {
        breakegg(type = 'b') {
            this.showBreakEggAnimate = true
            this.breakEggImgList = []
            switch (type) {
                case 'b':
                    this.breakEggImgList = this.eggb_ani
                    break;
                case 'g':
                    this.breakEggImgList = this.eggg_ani
                    break;
                case 'r':
                    this.breakEggImgList = this.eggr_ani
                    break;

                default:
                    break;
            }
            let length = this.breakEggImgList.length;
            let animateFn = () => {
                if (this.aniIndex < length - 1) {
                    this.aniIndex++;
                    setTimeout(() => {
                        window.requestAnimationFrame(animateFn);
                    }, this.fps);
                } else {
                    cancelAnimationFrame(animateFn);
                    setTimeout(() => {
                        this.showBreakEggAnimate = false
                        this.aniIndex = 0;
                        this.showModalTrigger = true
                    },1000)
                }
            }
            window.requestAnimationFrame(animateFn);
        },
        backHome() {
          this.$emit('closeDialog' , false)
          // this.$router.push("/lottery?user=0906366463&p=1688&token=NjMwMzE0NDgtZWYwMS00M2YwLWI5YmMtNzhlMDQ1NDMwODY3&peid=1681107092")
        }
    },
    mounted() {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/lottery_hitegg.vue